import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./components/App";
import HttpsRedirect from "react-https-redirect";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HttpsRedirect>
    <App />
  </HttpsRedirect>
);
